import { useQuery } from '@tanstack/react-query';
import { getValuations } from '../api/valuation/valuationApi';

export const useValuations = (): {
  initializing: boolean;
  valuationsCount?: number;
} => {
  const { isLoading, isError, isFetching, data } = useQuery<{ valuationsCount: number }, Error>({
    queryKey: ['valuation'],
    queryFn: getValuations,
  });

  return {
    initializing: isLoading || isFetching || isError,
    valuationsCount: data?.valuationsCount,
  };
};
